<template>
    <div class="row">
        <div class="col-4">
            <label :for="$id">
                {{ question.description }}
            </label>
        </div>
        <div class="col-8">
            <textarea
                v-if="question.displayType === 'textarea'"
                
                :id="$id"
                class="w-100"
                :readonly="readonly"

                v-model="valueModel"
            />
            
            <template v-if="question.displayType === 'radiobutton'">
                <div v-for="(option, index) in question.options"
                    class="form-check form-check-inline"
                >
                    <input type="radio"
                           :id="`${$id}_${index}`"
                           :name="`${$id}_${index}`"
                           :value="option.value"
                           
                           class="form-check-input"
                           :disabled="readonly"
                           
                           v-model="valueModel"
                    >

                    <label :for="`${$id}_${index}`" class="form-check-label">
                        {{ option.label }}
                    </label>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
let _componentId = 1;

export default {
    name: "Question",
    
    props: {
        question: {
            type: Object,
            required: true
        },

        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        
        value: {
            type: String,
            required: false
        }
    },
    
    computed: {
        valueModel: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    
    created() {
        //Some unique value for each instance
        this.$id = `q_${_componentId++}`;
    }
}
</script>
